/**
 * 版本號工具函數
 * 從原生平台讀取 app 版本資訊
 */

import { App } from '@capacitor/app'

// 判斷平台
const isCapacitor = typeof window !== 'undefined' && (window as any).Capacitor !== undefined
const platform = isCapacitor ? (window as any).Capacitor?.getPlatform?.() : 'web'

/**
 * 取得 App 版本資訊
 * @returns {Promise<{version: string, build: string}>}
 */
export async function getAppVersion(): Promise<{ version: string; build: string }> {
  if (!isCapacitor) {
    // Web 環境：返回預設值
    return {
      version: '1.0.0',
      build: '1'
    }
  }

  try {
    const info = await App.getInfo()
    return {
      version: info.version, // iOS: CFBundleShortVersionString, Android: versionName
      build: info.build      // iOS: CFBundleVersion, Android: versionCode
    }
  } catch (error) {
    console.error('無法取得 App 版本資訊:', error)
    return {
      version: 'Unknown',
      build: 'Unknown'
    }
  }
}

/**
 * 取得格式化的版本字串
 * @returns {Promise<string>} 例如: "v1.1.10 (8)" 或 "v1.1.4 (2)"
 */
export async function getFormattedVersion(): Promise<string> {
  const { version, build } = await getAppVersion()
  return `v${version} (${build})`
}

/**
 * 取得平台名稱
 * @returns {string} 'ios' | 'android' | 'web'
 */
export function getPlatform(): string {
  return platform
}
